// Cấu hình API domain và endpoints
import { getEnvironmentConfig } from './environment';

interface ApiConfig {
  BASE_URL: string;
  ENDPOINTS: {
    AUTH: {
      LOGIN: string;
      REGISTER: string;
      STRAVA_AUTH: string;
      STRAVA_CALLBACK: string;
      REFRESH_TOKEN: string;
    };
    TEAMS: {
      GET_USER_TEAMS: string;
      DISCOVER: string;
      SEARCH: string;
      CREATE: string;
      GET_ALL: string;
      UPDATE: string;
      DELETE: string;
    };
    ADMIN: {
      TEAMS: {
        GET_ALL: string;
        UPDATE: string;
        DELETE: string;
      };
    };
    TOURNAMENTS: {
      GET_ALL: string;
      GET_BY_ID: string;
      CREATE: string;
      UPDATE: string;
      DELETE: string;
    };
    USERS: {
      GET_BY_ID: string;
    };
    CLUBS: {
      SYNC_STATUS: string;
      TRIGGER_SYNC: string;
    };
    CHATBOT: {
      SEND_MESSAGE: string;
    };
    // Thêm các endpoint khác khi cần
  };
}

// Định nghĩa các endpoint không thay đổi theo môi trường
const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    STRAVA_AUTH: '/api/auth/strava/auth',
    STRAVA_CALLBACK: '/api/auth/strava/callback',
    REFRESH_TOKEN: '/api/auth/refresh-token',
  },
  TEAMS: {
    GET_USER_TEAMS: '/api/teams',
    DISCOVER: '/api/teams/discover',
    SEARCH: '/api/teams/search',
    CREATE: '/api/teams',
    GET_ALL: '/api/teams',
    UPDATE: '/api/teams',
    DELETE: '/api/teams',
  },
  ADMIN: {
    TEAMS: {
      GET_ALL: '/api/admin/teams',
      UPDATE: '/api/admin/teams',
      DELETE: '/api/admin/teams',
    },
  },
  TOURNAMENTS: {
    GET_ALL: '/api/tournaments',
    GET_BY_ID: '/api/tournaments',
    CREATE: '/api/tournaments',
    UPDATE: '/api/tournaments',
    DELETE: '/api/tournaments',
  },
  USERS: {
    GET_BY_ID: '/api/users',
  },
  CLUBS: {
    SYNC_STATUS: '/api/clubs/sync-status',
    TRIGGER_SYNC: '/api/clubs/trigger-sync',
  },
  CHATBOT: {
    SEND_MESSAGE: '/api/chatbot/chat',
  },
};

// Tạo cấu hình dựa trên môi trường hiện tại
const createConfig = (): ApiConfig => {
  const env = getEnvironmentConfig();
  
  return {
    BASE_URL: env.apiDomain,
    ENDPOINTS: API_ENDPOINTS,
  };
};

const CONFIG = createConfig();

// Helper function để tạo URL đầy đủ
export const getApiUrl = (path?: string): string => {
  const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';
  if (!path) return baseUrl;
  
  const fullUrl = `${baseUrl}${path}`;
  console.log(`API URL được tạo: ${fullUrl}`);
  return fullUrl;
};

// Helper function để lấy URL frontend
export const getFrontendUrl = (): string => {
  return process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3000';
};

export default CONFIG; 